import React, { FC } from 'react';
import { useQuery } from '@apollo/client';
import { netCancellationStatisticsQuery } from '@/graph/dashboard';
import type { NetCancellationStatisticsQueryData } from '@/types/NetCancellationStatistics';
import NetCancellationRateWidget from './NetCancellationRateWidget';

const NetCancellationRateChart: FC<{ filter: any }> = ({ filter }) => {
  const { data, loading, error } = useQuery<NetCancellationStatisticsQueryData>(netCancellationStatisticsQuery, {
    variables: { filter },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });

  return (
    <NetCancellationRateWidget
      statistics={loading || error ? null : data?.netCancellationStatistics}
      loading={loading}
      failed={!!error}
    />
  );
};

export default NetCancellationRateChart;
